// import pacchetti
import { useState } from "react";

// import hooks
import { useFirestore } from "../../hooks/useFirestore";
import { useUserRole } from "../../hooks/useUserRole";
// import { useCollection } from "../../hooks/useCollection"; // Non utilizzato per ora

// import componenti
import ProjectDetails from "./ProjectDetails";
import ProjectEditForm from "./ProjectEditForm";
import ProjectFiles from "./ProjectFiles";
import ProjectDelete from "./ProjectDelete";
// eslint-disable-next-line no-unused-vars
import ProjectComments from "./ProjectComments";
import ProjectTitle from "./ProjectTitle";
import WorkOrders from "./WorkOrders";
import ProjectFinancials from "./ProjectFinancials";
import ProjectSAL from "./ProjectSAL";
import ProjectManodopera from "./ProjectManodopera";

// import styles
import "./Project.css";

export default function ProjectSummary({ prj }) {
  const { updateDocument, deleteDocument } = useFirestore("projects");
  const { isAdmin } = useUserRole();
  const [editMode, setEditMode] = useState(false);

  // Stato per il tab attivo
  const [activeTab, setActiveTab] = useState("details");

  // Gestione modifica dati progetto
  const handleEditClick = () => {
    setEditMode(true);
  };

  const handleSaveEdit = async (projectData) => {
    try {
      // Se c'è una data di scadenza in formato stringa, convertiamola in Timestamp
      if (projectData.scadenza && typeof projectData.scadenza === "string") {
        // Importiamo il timestamp da firebase/config
        const { timestamp } = require("../../firebase/config");
        // Convertiamo la stringa in un oggetto Date e poi in un Timestamp
        const dateObj = new Date(projectData.scadenza);
        projectData.scadenza = timestamp.fromDate(dateObj);
      }

      await updateDocument(prj.id, projectData);
      setEditMode(false);
    } catch (error) {
      console.error("Errore durante il salvataggio delle modifiche:", error);
    }
  };

  const handleCancelEdit = () => {
    setEditMode(false);
  };

  // Gestione aggiornamento costi
  const handleUpdateCosti = async (updateData) => {
    try {
      await updateDocument(prj.id, updateData);
    } catch (error) {
      console.error("Errore durante l'aggiornamento dei costi:", error);
    }
  };

  // Gestione aggiornamento stato
  const handleUpdateStatus = async (completato) => {
    try {
      await updateDocument(prj.id, { completato });
    } catch (error) {
      console.error("Errore durante l'aggiornamento dello stato:", error);
    }
  };

  // Gestione eliminazione progetto
  const handleDelete = async () => {
    try {
      await deleteDocument(prj.id);
      // La navigazione alla home avverrà automaticamente grazie al redirect in useFirestore
    } catch (error) {
      console.error("Errore durante l'eliminazione del progetto:", error);
    }
  };

  // Gestione cambio tab
  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  // Definizione delle icone SVG per i componenti
  const icons = {
    details: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="16" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12.01" y2="8"></line>
      </svg>
    ),
    costs: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="12" y1="1" x2="12" y2="23"></line>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
      </svg>
    ),
    files: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10 9 9 9 8 9"></polyline>
      </svg>
    ),
    status: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
      </svg>
    ),
    delete: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="3 6 5 6 21 6"></polyline>
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
        <line x1="10" y1="11" x2="10" y2="17"></line>
        <line x1="14" y1="11" x2="14" y2="17"></line>
      </svg>
    ),
    workOrders: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
      </svg>
    ),
    comments: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
      </svg>
    ),
    financials: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 3v18h18"></path>
        <path d="M18 17V9"></path>
        <path d="M13 17V5"></path>
        <path d="M8 17v-3"></path>
      </svg>
    ),
    sal: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4"></path>
        <path d="M9 11V9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path>
        <path d="M12 16v4"></path>
        <path d="M8 16l4-4 4 4"></path>
      </svg>
    ),
  };

  return (
    <>
      <ProjectTitle prj={prj} onEditClick={handleEditClick} />

      {/* Tabs di navigazione */}
      <div className="components-console">
        <div className="console-title">Sezioni del progetto</div>
        <div className="console-buttons tabs">
          <button
            className={`console-btn ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabChange("details")}
            title="Informazioni Progetto"
          >
            {icons.details} Info
          </button>

          {prj.tipoProject === "cantiere" && (
            <button
              className={`console-btn ${activeTab === "sal" ? "active" : ""}`}
              onClick={() => handleTabChange("sal")}
              title="Stato Avanzamento Lavori"
            >
              {icons.sal} SAL
            </button>
          )}

          <button
            className={`console-btn ${activeTab === "files" ? "active" : ""}`}
            onClick={() => handleTabChange("files")}
            title="File del Progetto"
          >
            {icons.files} File
          </button>

          <button
            className={`console-btn ${
              activeTab === "workOrders" ? "active" : ""
            }`}
            onClick={() => handleTabChange("workOrders")}
            title="Gestione Ricavi"
          >
            {icons.workOrders} Ricavi
          </button>

          <button
            className={`console-btn ${
              activeTab === "manodopera" ? "active" : ""
            }`}
            onClick={() => handleTabChange("manodopera")}
            title="Dettaglio Manodopera"
          >
            {icons.manodopera} Manodopera
          </button>

          <button
            className={`console-btn ${
              activeTab === "comments" ? "active" : ""
            }`}
            onClick={() => handleTabChange("comments")}
            title="Commenti"
          >
            {icons.comments} Commenti
          </button>

          {isAdmin && (
            <button
              className={`console-btn ${
                activeTab === "financials" ? "active" : ""
              }`}
              onClick={() => handleTabChange("financials")}
              title="Analisi Finanziaria"
            >
              {icons.financials} Analitica
            </button>
          )}

          {isAdmin && (
            <button
              className={`console-btn icon-only ${
                activeTab === "delete" ? "active" : ""
              }`}
              onClick={() => handleTabChange("delete")}
              title="Eliminazione Progetto"
            >
              {icons.delete}
            </button>
          )}
        </div>
      </div>

      <div className="project-summary">
        {editMode ? (
          <div className="component-container">
            <h3>Modifica Progetto</h3>
            <ProjectEditForm
              prj={prj}
              onSave={handleSaveEdit}
              onCancel={handleCancelEdit}
            />
          </div>
        ) : (
          <>
            {/* Tab Dettagli */}
            {activeTab === "details" && (
              <div className="component-container">
                <h3>Dettagli Progetto</h3>
                <ProjectDetails
                  prj={prj}
                  editMode={editMode}
                  onEditClick={handleEditClick}
                />
              </div>
            )}

            {/* Tab SAL */}
            {activeTab === "sal" && prj.tipoProject === "cantiere" && (
              <div className="component-container sal">
                <h3>Stato Avanzamento Lavori</h3>
                <ProjectSAL
                  prj={prj}
                  onUpdate={handleUpdateCosti}
                  onUpdateStatus={handleUpdateStatus}
                />
              </div>
            )}

            {/* Tab File */}
            {activeTab === "files" && (
              <div className="component-container files">
                <h3>File del Progetto</h3>
                <ProjectFiles prj={prj} />
              </div>
            )}

            {/* Tab Elimina - visibile solo agli admin */}
            {activeTab === "delete" && isAdmin && (
              <div className="component-container delete">
                <h3>Eliminazione Progetto</h3>
                <ProjectDelete onDelete={handleDelete} />
              </div>
            )}

            {/* Tab Ordini */}
            {activeTab === "workOrders" && (
              <div className="component-container">
                <h3>Gestione Ricavi</h3>
                <WorkOrders prj={prj} />
              </div>
            )}

            {/* Tab Manodopera */}
            {activeTab === "manodopera" && (
              <div className="component-container manodopera">
                <h3>Dettaglio Manodopera</h3>
                <ProjectManodopera prj={prj} />
              </div>
            )}

            {/* Tab Commenti */}
            {activeTab === "comments" && (
              <div className="component-container comments">
                <h3>Commenti</h3>
                <ProjectComments prj={prj} />
              </div>
            )}

            {/* Tab Finanze - visibile solo agli admin */}
            {activeTab === "financials" && isAdmin && (
              <div className="component-container financials">
                <h3>Analitica Settore</h3>
                <ProjectFinancials prj={prj} />
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}
